import { render } from "./ExternalApiKeyUpdatePermissionsModal.vue?vue&type=template&id=694bcc7c"
import script from "./ExternalApiKeyUpdatePermissionsModal.vue?vue&type=script&lang=js"
export * from "./ExternalApiKeyUpdatePermissionsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__